import React from "react";
import Button from "../../ui/button/Button";
import './Subheader.css'

export default function Subheader() {
    return (
        <section className="main-subheader">
            <div className="container subheader">
                <Button props={ {type: "section-button-main" , name: "Узнать больше"}  } />
            </div>
        </section>
    )
}
